import React, { useEffect, useState } from 'react';
import './connectedAccounts.css';
import { auth } from '../../../firebase';
import { CLIENT_ID, SCOPES } from '../../../googleOAuth';
import axios from 'axios';

import youtube_dark_logo from '../../../assets/images/logo/youtube-dark-logo.png';
import youtube_red_logo from '../../../assets/images/logo/youtube-red-logo.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClapperboard } from '@fortawesome/free-solid-svg-icons';

const ConnectedAccounts = ({ profileImage, accessToken }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [channelHandle, setChannelHandle] = useState('');

  useEffect(() => {
    if (!accessToken) {
      setIsConnected(false);
      return;
    }

    setIsConnected(true);

    const checkAndFetchChannelHandle = async () => {
      const user = auth.currentUser;
      if (user) {
        const storedHandle = checkLocalStorage(user.uid);
        if (storedHandle) {
          setChannelHandle(storedHandle);
        } else {
          await fetchChannelDetails(user.uid);
        }
      }
    };

    const checkLocalStorage = (userId) => {
      const storageKeys = Object.keys(localStorage);
      const relevantKey = storageKeys.find(
        (key) => key.startsWith(`${userId}_`) && key.endsWith('_YThandle')
      );
      return relevantKey ? localStorage.getItem(relevantKey) : null;
    };

    const fetchChannelDetails = async (userId) => {
      try {
        const response = await axios.get(
          'https://www.googleapis.com/youtube/v3/channels',
          {
            params: {
              part: 'snippet',
              mine: true,
              access_token: accessToken,
            },
          }
        );

        if (response.data.items.length > 0) {
          const channel = response.data.items[0];
          const handle = channel.snippet.customUrl || channel.snippet.title;
          const channelId = channel.id;

          const youtubeChannelHandleKey = `${userId}_${channelId}_YThandle`;
          localStorage.setItem(youtubeChannelHandleKey, handle);
          setChannelHandle(handle);
        }
      } catch (error) {
        // console.error('Error fetching YouTube channel details:', error);
      }
    };

    checkAndFetchChannelHandle();
  }, [accessToken]);

  const handleConnectYouTube = () => {
    const user = auth.currentUser;
    const userId = user ? user.uid : null;
    const connectYoutubeUrl = `${process.env.REACT_APP_FUNCTIONS_ENDPOINT}/connectYoutube`;

    if (userId) {
      const authUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
        connectYoutubeUrl
      )}&scope=${encodeURIComponent(
        SCOPES
      )}&response_type=code&access_type=offline&state=${userId}`;
      window.location.href = authUrl;
    }
  };

  const title = 'Bumpups Creator';
  const description = 'Publish your videos on YouTube';
  const link =
    'https://intercom.help/bumpups/en/articles/9650593-how-do-i-publish-my-video-with-bump-ai';

  const openLink = () => {
    window.open(link, '_blank');
  };

  return (
    <div className="connectui-info-box">
      <div className="connectui-center-section">
        <img
          src={profileImage}
          alt="Creator Avatar"
          className="connectui-avatar"
        />
        <div className="connectui-wrapper">
          <div className="connectui-distribution-title">Platforms</div>
          <button
            className={`connectui-connectYouTube-button ${
              isConnected ? 'connected' : ''
            }`}
            onClick={() =>
              isConnected
                ? window.open(`https://www.youtube.com/${channelHandle}`, '_blank')
                : handleConnectYouTube()
            }
            style={{ cursor: 'pointer' }}
          >
            <img
              src={isConnected ? youtube_red_logo : youtube_dark_logo}
              alt="YouTube Button"
              className="connectui-connectyoutube"
            />
          </button>
          {isConnected && channelHandle && (
            <div className="connectui-channel-handle">{channelHandle}</div>
          )}
        </div>
      </div>

      <div className="connectui-processing-container">
        <div className="connectui-processing-card">
          <div className="connectui-processing-content">
            <div className="connectui-subtitle">How it works?</div>
            <div className="connectui-title">{title}</div>
            <div className="connectui-description">{description}</div>
            <div className="connectui-processing-actions">
              <button
                className="connectui-processing-start-btn"
                onClick={openLink}
              >
                READ NOW
              </button>
            </div>
          </div>
          <div className="connectui-processing-icon">
            <FontAwesomeIcon
              className="connectui-upload-icon"
              icon={faClapperboard}
              title={title}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectedAccounts;
